import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { label: 'Coffee',    href: '/shop'  },
  { label: 'Cafés',    href: '/cafes' },
  { label: 'Menu',     href: '/menu'  },
  { label: 'About',    href: '/about' },
];

export default function Navbar() {
  const [open,       setOpen]       = useState(false);
  const [scrolled,   setScrolled]   = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // close mobile menu on route change
  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <nav className={`sticky top-0 z-50 transition-all duration-400 ${
      scrolled
        ? 'bg-maroon/95 backdrop-blur-sm shadow-lg shadow-maroon/20'
        : 'bg-maroon'
    }`}>
      <div className="flex items-center justify-between px-6 md:px-14 py-5">

        {/* Logo */}
        <Link to="/" className="font-serif text-xl font-light tracking-[0.1em] text-light">
          Roastery <span className="text-sand opacity-60">•</span> Coffee House
        </Link>

        {/* Desktop links */}
        <ul className="hidden md:flex gap-10 list-none">
          {links.map(l => (
            <li key={l.href}>
              <Link
                to={l.href}
                className={`text-xs tracking-[0.12em] uppercase transition-colors duration-300 link-underline ${
                  pathname === l.href
                    ? 'text-light'
                    : 'text-sand/70 hover:text-light'
                }`}
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <Link
          to="/shop"
          className="hidden md:block border border-sand/30 text-light text-xs font-medium tracking-[0.12em] uppercase px-5 py-2.5 hover:bg-light hover:text-maroon transition-all duration-300"
        >
          Shop Beans
        </Link>

        {/* Hamburger */}
        <button onClick={() => setOpen(!open)} className="md:hidden p-1 flex flex-col gap-1.5" aria-label="Menu">
          <span className={`block h-px w-6 bg-light transition-all duration-300 ${open ? 'rotate-45 translate-y-[7px]' : ''}`} />
          <span className={`block h-px w-6 bg-light transition-all duration-300 ${open ? 'opacity-0' : ''}`} />
          <span className={`block h-px w-6 bg-light transition-all duration-300 ${open ? '-rotate-45 -translate-y-[7px]' : ''}`} />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden overflow-hidden transition-all duration-400 ease-spring ${open ? 'max-h-96' : 'max-h-0'}`}>
        <div className="px-6 pb-6 pt-2 flex flex-col gap-0 border-t border-sand/10">
          {links.map(l => (
            <Link
              key={l.href}
              to={l.href}
              className={`text-sm tracking-widest uppercase py-4 border-b border-sand/10 transition-colors ${
                pathname === l.href ? 'text-light' : 'text-sand/65 hover:text-light'
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/shop" className="mt-5 bg-light text-maroon text-xs font-medium tracking-widest uppercase px-5 py-3 text-center">
            Shop Beans
          </Link>
        </div>
      </div>
    </nav>
  );
}
